import ColorCurve from '@/assets/js/ColorCurve';

export default class Contrast {
	constructor() {
		this.minValue = -100;
		this.maxValue = 100;
		this.calcValue = 100;
		this.blockName = "contrast";
	}

	addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate(this.blockName, blockNum);
		let blockCanvasName = UI.createBlockCanvas(this.blockName, blockNum);
		var element = UI.getAdjustmentBlock(blockNum);

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);
		$(element)
			.find(".contrast_slider")
			.on("input", _ => this.contrastSliderHandler($(element)));
		$(element)
			.find(".contrast_range")
			.on("change", _ => this.contrastValueHandler($(element)));

		UI.initKnob(element, {
			size: 30,
		});

		blocks.add({
			name: "contrast",
			curves: [
				{
					name: blockCanvasName,
					colorCurve: new ColorCurve(blockCanvasName),
				},
			],
			passes: [this.addContrastPass()],
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			values: {
				contrast: 0,
			},
		});
	}

	addContrastPass() {
		let shaderPass = gpu.createCurveShaderPass(this.blockName);
		gpu.addPassToComposer(shaderPass, "toMiddle");
		return shaderPass;
	}

	contrastSliderHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		var contrastValue = UI.getAdjustmentBlock_sliderValue($el);
		UI.setAdjustmentBlock_rangeValue($el, contrastValue);

		let block = lutify.getActiveBlock();
		block.values.contrast = contrastValue / this.calcValue;
		this.curveContrast(block.values.contrast);
	}

	contrastValueHandler($el) {
		blocks.checkSwitchHandler($el);
		lutify.getActiveBlock().passes[0].enabled = true;

		let contrastValue = UI.getAdjustmentBlock_rangeValue($el);

		if (contrastValue > this.maxValue) {
			contrastValue = this.maxValue;
			UI.setAdjustmentBlock_rangeValue($el, contrastValue);
		}
		if (contrastValue < this.minValue) {
			contrastValue = this.minValue;
			UI.setAdjustmentBlock_rangeValue($el, contrastValue);
		}

		UI.setAdjustmentBlock_sliderValue($el, contrastValue);
		lutify.getActiveBlock().values.contrast = contrastValue / this.calcValue;
		this.curveContrast(lutify.getActiveBlock().values.contrast);
	}

	curveContrast(contrastVal) {
		let curve = lutify.getActiveBlock().curves[0].colorCurve;
		curve.points = [];

		if (contrastVal > 0) {
			curve.points.push({ x: 0, y: 0 });
			curve.points.push({ x: 0.25 + 0.125 * contrastVal, y: 0.25 });
			curve.points.push({ x: 0.75 - 0.125 * contrastVal, y: 0.75 });
			curve.points.push({ x: 1.0, y: 1.0 });
		} else {
			curve.points.push({ x: 0, y: 0 });
			curve.points.push({ x: 0.25, y: 0.25 + Math.abs(0.125 * contrastVal) });
			curve.points.push({ x: 0.75, y: 0.75 + 0.125 * contrastVal });
			curve.points.push({ x: 1.0, y: 1.0 });
		}

		curve.draw();
		curve.updateValues();
		this.callGPUContrast(curve.rgb);
	}

	callGPUContrast(points) {
		let curveTexture = gpu.pointsToCurve(points);
		lutify.getActiveBlock().passes[0].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	applyChanges($block, values) {
		let contrast = values.contrast * this.calcValue;
		UI.setAdjustmentBlock_rangeValue($block, contrast);
		$block.find(".contrast_range").trigger("change");
	}
}
